/* eslint-disable max-len */
import { IconProps } from 'components/Icons';

const RadiantLogo = ({ width = 187, height = 29, className = '' }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 187 29"
    fill="none"
  >
    <g clipPath="url(#clip0_3806_4881)">
      <path
        d="M77.1469 28.4714C80.6173 26.0698 83.1541 22.4062 84.0942 18.1503C84.4869 16.9978 84.6994 15.7681 84.6994 14.4868C84.6994 13.2055 84.4869 11.9757 84.0942 10.8232C82.9932 7.61039 80.495 5.0414 77.3272 3.85026C76.091 3.38669 74.7454 3.12914 73.3482 3.12914H66.6392V23.3269H63.5036V0H73.3546C74.6681 0 75.9429 0.173841 77.1534 0.508647C83.3087 2.18267 87.8414 7.81642 87.8414 14.4932C87.8414 21.17 83.3022 26.8038 77.1534 28.4778L77.1469 28.4714Z"
        fill="#005486"
      />
      <path
        d="M81.6797 11.5186C81.0294 9.70292 79.7739 8.13191 78.1707 7.08243L79.4004 5.75608H74.7389L75.6725 9.78019L77.0182 8.33151C78.1707 10.1086 78.8531 12.2204 78.8531 14.4932C78.8531 18.0022 77.2499 21.1443 74.7453 23.2304C72.7751 24.8658 70.2512 25.8509 67.5019 25.8509H60.793V0H57.6574V28.98H67.5084C71.3007 28.98 74.7582 27.5184 77.3401 25.1233C77.4624 25.0138 77.5783 24.8979 77.6942 24.7821C79.0463 23.4428 80.1344 21.8461 80.8813 20.0626C80.9328 19.9402 80.9779 19.8244 81.0229 19.702C81.1131 19.4702 81.1968 19.2384 81.2741 19.0002C81.3127 18.8843 81.3513 18.762 81.3835 18.6461C81.4028 18.5882 81.4221 18.5238 81.435 18.4658C81.4672 18.3499 81.4994 18.2405 81.5252 18.1246C81.5445 18.0537 81.5573 17.9894 81.5767 17.9185C81.6024 17.8155 81.6282 17.7125 81.6475 17.6095L81.6797 17.4743C81.8793 16.5085 81.9887 15.5105 81.9887 14.4868C81.9887 13.463 81.8857 12.4779 81.6797 11.5186Z"
        fill="url(#paint0_linear_3806_4881)"
      />
      <path
        d="M17.7576 28.9235L9.93471 17.6238H3.81807V28.9235H-3.8147e-06V0.484375H12.3299C17.9443 0.484375 21.9491 3.81311 21.9491 9.05411C21.9491 14.2951 18.1761 16.9864 13.991 17.3277L22.271 28.93H17.764L17.7576 28.9235ZM11.8727 3.63927H3.81807V14.514H11.8727C15.5105 14.514 17.9894 12.2541 17.9894 9.05411C17.9894 5.85414 15.5041 3.63927 11.8727 3.63927Z"
        fill="#005486"
      />
      <path
        d="M50.0148 28.9235L47.2977 22.6137H31.7486L29.0315 28.9235H24.8014L37.1312 0.484375H41.87L54.245 28.93H50.0148V28.9235ZM39.5264 3.63927L32.856 19.4588H46.1517L39.5264 3.63927Z"
        fill="#005486"
      />
      <path d="M91.7045 28.9235V0.484375H95.5226V28.93H91.7045V28.9235Z" fill="#005486" />
      <path
        d="M124.741 28.9235L122.024 22.6137H106.475L103.758 28.9235H99.5274L111.857 0.484375H116.596L128.971 28.93H124.741V28.9235ZM114.252 3.63927L107.582 19.4588H120.878L114.252 3.63927Z"
        fill="#005486"
      />
      <path
        d="M154.699 28.9235L136.8 5.98291V28.9235H132.982V0.484375H136.89L154.558 22.955V0.484375H158.376V28.93H154.693L154.699 28.9235Z"
        fill="#005486"
      />
      <path
        d="M173.146 28.9235V3.63927H163.437V0.484375H186.719V3.63927H176.964V28.93H173.146V28.9235Z"
        fill="#005486"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3806_4881"
        x1="57.6445"
        y1="14.4932"
        x2="81.9823"
        y2="14.4932"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1C75BC" />
        <stop offset="1" stopColor="#00B6BE" />
      </linearGradient>
      <clipPath id="clip0_3806_4881">
        <rect width="186.719" height="28.98" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default RadiantLogo;
